var rotationDial =
webpackJsonp_name_([8],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(63);


/***/ },

/***/ 63:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(64);

/***/ },

/***/ 64:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _rotationDialControl = __webpack_require__(65);

	var _rotationDialControl2 = _interopRequireDefault(_rotationDialControl);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var loader = {
	    name: 'us:rotation-dial',

	    extends: 'viewport',

	    constructor: function (_RotationDialControl) {
	        _inherits(hackRotationDial, _RotationDialControl);

	        function hackRotationDial(uScope, viewport) {
	            _classCallCheck(this, hackRotationDial);

	            // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
	            var _this = _possibleConstructorReturn(this, (hackRotationDial.__proto__ || Object.getPrototypeOf(hackRotationDial)).call(this, uScope, viewport));

	            viewport.rotationDial = _this;

	            uScope.events.on('uScope:command:log-settings', function (log) {
	                log('--- enabled: Rotation Dial');
	            });
	            return _this;
	        }

	        return hackRotationDial;
	    }(_rotationDialControl2.default)
	};

	_publicApi2.default.plugins.register(loader);

/***/ },

/***/ 65:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RotationDialControl;

	var _lodashLite = __webpack_require__(9);

	var _ = _interopRequireWildcard(_lodashLite);

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	var defaults = {
	    layout: { 'divClass': _defines2.default.clsROTATIONDIV, 'precinct': 'BL', 'order': 2 }
	};

	// NOTE: This control depends upon jquery plugin: knob.js https://github.com/aterrien/jQuery-Knob
	function RotationDialControl(uScope, viewport) {
	    var self = this;
	    var imageId_ = viewport.getImageId();
	    var uScopeIdx_ = viewport.getImageId();

	    var isLoaded = false; // rotation dial has been loaded

	    var jVpDiv = viewport.vpDivGet('outer');
	    var jRotationDiv;
	    var jRotationDial;
	    var jPresets;

	    var prefVisibleDef = false; // rotation dial visibility preference default

	    var navModesImHiddenIn = {}; // what navigation modes not to display the label

	    var layout = _.clone(defaults.layout);
	    var reLayout = viewport.overLayout.refreshPrecinct;

	    //............................................ construct_() local
	    var construct_ = function construct_() {
	        if (_defines2.default.ENABLEROTATION == false) return;

	        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide rotation dial in rasterscan mode
	        navModesImHiddenIn[_defines2.default.eNavModes.nmAutoPan] = true; // hide rotation dial in when auto panning
	        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide rotation dial when drawing any annotation

	        load_(); // load the rotation dial
	    };
	    //............................................ show() public
	    self.show = function (show) {
	        if (isLoaded == false) return;
	        //debug-only viewport.log("rotation dial show(" + show + ")" + "   pref: " + uScope.prefGet(us.clsROTATIONDIV, prefVisibleDef));

	        // prevent show if preference is not to show
	        if (uScope.prefGet(_defines2.default.clsROTATIONDIV, prefVisibleDef) == false) jRotationDiv.hide();else if (show == true) jRotationDiv.show();else jRotationDiv.hide();

	        reLayout(layout.precinct); // layout just this overlay's precinct
	    };
	    //............................................ rotate() public
	    //    This function changes the rotation dial's value as if the user changed it.
	    self.setValue = function (angleDeg) {
	        if (jRotationDial != undefined) {
	            angleDeg = angleDeg % 360;
	            if (angleDeg < 0) angleDeg += 360;
	            //debug-only viewport.log("rotationDial: setValue: " + angleDeg);
	            jRotationDial.val(angleDeg).trigger('change');

	            viewport.viewRotate(angleDeg); //ol3 added // when click preset is 0 nothing happens, only 0?
	        }
	    };

	    //............................................ rotate() public
	    //    This function changes the rotation dial's value as if the user changed it.
	    self.getValue = function () {
	        //debug-only viewport.log("rotationDial: getValue: " + parseInt(jRotationDial.val()));
	        return parseInt(jRotationDial.val());
	    };

	    //............................................ load_() local
	    //    This function creates the rotation dial.
	    var load_ = function load_() {
	        if (jRotationDiv) return;

	        self.change = function (val) {
	            //debug-only viewport.log("rotation dial change callback: angle: " + val);
	            viewport.viewRotate(val);
	        };

	        self.draw = function () {
	            var self = this;
	            if (self.$.data('skin') == 'aperio') {
	                //debug-only viewport.log("Rotation draw callback: aperio skin draw called: angle: " + self.val());
	                ////viewport.log("rotation draw callback: vp angle: " + viewport.angleDeg + "  control angle: " + self.cv);

	                // because the rotation control's read out can be edited and that user change does not callback to the change event,
	                //    a copy of the angle must be maintained and checked in the draw event and rotate the viewport if necessary.
	                var curAngleDeg = viewport.getViewAngle(true);
	                if (curAngleDeg != self.cv) {
	                    //debug-only viewport.log("............performing rotation: " + self.cv);
	                    viewport.viewRotate(self.cv); // perform image rotation first
	                }
	                var a = self.angle(self.cv) // Angle in radians
	                ,
	                    sa = self.startAngle // Previous start angle
	                ,
	                    sat = self.startAngle // Start angle
	                ,
	                    ea // Previous end angle
	                ,
	                    eat = sat + a // End angle
	                ,
	                    r = 1;

	                self.g.lineWidth = self.lineWidth;

	                self.o.cursor && (sat = eat - 0.25) && (eat = eat + 0.25);

	                var arcWidth = self.radius - self.lineWidth - 5;
	                if (self.o.displayPrevious) {
	                    ea = self.startAngle + self.angle(self.v);
	                    self.o.cursor && (sa = ea - 0.25) && (ea = ea + 0.25);
	                    self.g.beginPath();
	                    self.g.strokeStyle = self.pColor;
	                    //orig      self.g.arc(self.xy, self.xy, self.radius - self.lineWidth, sa, ea, false);
	                    self.g.arc(self.xy, self.xy, arcWidth, sa, ea, false);
	                    self.g.stroke();
	                }

	                // draw the arc at current angle
	                self.g.beginPath();
	                self.g.strokeStyle = r ? self.o.fgColor : self.fgColor;
	                //orig                             self.g.arc(self.xy, self.xy, self.radius - self.lineWidth, sat, eat, false);
	                self.g.arc(self.xy, self.xy, arcWidth, sat, eat, false);
	                self.g.stroke();

	                // draw the outer circle
	                self.g.lineWidth = 2;
	                self.g.beginPath();
	                self.g.strokeStyle = self.o.fgColor;
	                self.g.arc(self.xy, self.xy, self.radius - self.lineWidth + 1 + self.lineWidth * 2 / 3, 0, 2 * Math.PI, false);
	                self.g.stroke();
	                // draw an inner circle
	                self.g.beginPath();
	                self.g.strokeStyle = self.o.fgColor;
	                self.g.arc(self.xy, self.xy, self.radius * 1 / 3, 0, 2 * Math.PI, false);
	                self.g.stroke();

	                // draw a line from center to end
	                var len = self.radius; // -self.lineWidth;
	                var cosa = Math.cos(a),
	                    sina = Math.sin(a);
	                var y0 = self.xy - len / 3 * cosa;
	                var x0 = self.xy + len / 3 * sina;
	                var y1 = self.xy - len * cosa;
	                var x1 = self.xy + len * sina;

	                self.g.beginPath();
	                self.g.moveTo(x0, y0);
	                self.g.lineTo(x1, y1);
	                self.g.stroke();
	                //viewport.log("angle =" + a + "  .....self.xy = " + self.xy + "..... x1,y1=" + x1 + "," + y1);
	                return false;
	            }
	        };

	        //..................................................
	        // closure functions
	        var drawFeetOrEars_ = function drawFeetOrEars_(drawFeet) {
	            if (drawFeet == true) {
	                var jPreset = $('<div/>', {
	                    'class': _defines2.default.clsROTATEPRESET + ' us_rotateOne', 'text': '<', 'angle': '+1', 'title': '+1 degree',
	                    css: { left: divDiamPx / 2 - 4 * presetDiamPx + 'px', top: divDiamPx - presetDiamPx + 'px' }
	                });
	                jRotationDiv.append(jPreset);
	                jPreset = $('<div/>', {
	                    'class': _defines2.default.clsROTATEPRESET + ' us_rotateOne', 'text': '>', 'angle': '-1', 'title': '-1 degree >>',
	                    css: { left: divDiamPx / 2 + 2 * presetDiamPx + 'px', top: divDiamPx - presetDiamPx + 'px' }
	                });
	                jRotationDiv.append(jPreset);
	            } else {

	                var jPreset = $('<div/>', {
	                    'class': _defines2.default.clsROTATEPRESET + ' us_rotateOne', 'text': '<', 'angle': '-1', 'title': '+1 degree',
	                    css: { left: divDiamPx / 2 - 4 * presetDiamPx + 'px', top: '-1px' }
	                });
	                jRotationDiv.append(jPreset);
	                jPreset = $('<div/>', {
	                    'class': _defines2.default.clsROTATEPRESET + ' us_rotateOne', 'text': '>', 'angle': '+1', 'title': '-1 degree >>',
	                    css: { left: divDiamPx / 2 + 2 * presetDiamPx + 'px', top: '-1px' }
	                });
	                jRotationDiv.append(jPreset);
	            }
	        };
	        var drawPresets_ = function drawPresets_() {
	            var midVerticalX = (divDiamPx - presetDiamPx) / 2 - 2;
	            var midHorizontalY = (divDiamPx - presetDiamPx) / 2 - 1;

	            // 0 and 180 degrees
	            var jPreset = $('<div/>', {
	                'class': _defines2.default.clsROTATEPRESET, 'angle': '0', 'title': '0 degrees',
	                css: { left: midVerticalX + 'px', top: '0px' }
	            });
	            jRotationDiv.append(jPreset);
	            jPreset = $('<div/>', {
	                'class': _defines2.default.clsROTATEPRESET, 'angle': '180', 'title': '180 degrees',
	                css: { left: midVerticalX + 'px', top: divDiamPx - presetDiamPx - 1 + 'px' }
	            });
	            jRotationDiv.append(jPreset);

	            // 90 and 270 degrees
	            jPreset = $('<div/>', {
	                'class': _defines2.default.clsROTATEPRESET, 'angle': '90', 'title': '90 degrees',
	                css: { left: dialDiamPx + presetDiamPx - 2 + 'px', top: midHorizontalY + 'px' }
	            });
	            jRotationDiv.append(jPreset);
	            jPreset = $('<div/>', {
	                'class': _defines2.default.clsROTATEPRESET, 'angle': '270', 'title': '270 degrees',
	                css: { left: '0px', top: midHorizontalY + 'px' }
	            });
	            jRotationDiv.append(jPreset);
	        };
	        //..................................................

	        var dialDiamPx = 64;
	        var presetDiamPx = 10;
	        var divDiamPx = dialDiamPx + 2 * presetDiamPx;

	        jRotationDiv = $('<div/>', { // first create an offscreen div that will contain the dial
	            'class': _defines2.default.clsROTATIONDIV + ' ' + _defines2.default.clsOVERLAY + ' ' + _defines2.default.clsTRANSPARENT, 'title': 'Rotation Dial',
	            css: {
	                'left': _defines2.default.kDEF_TILE_POS_PX,
	                'top': _defines2.default.kDEF_TILE_POS_PX,
	                width: divDiamPx + 'px',
	                height: divDiamPx + 'px'
	            }
	        });

	        drawPresets_(); // draw the presets on the outer ring
	        drawFeetOrEars_(true); // draw the feet on the outer ring

	        jRotationDial = $('<input/>', { // build the dial
	            'class': _defines2.default.clsROTATIONDIAL, 'data-skin': 'aperio'
	        });
	        var dialDiamPlus = dialDiamPx + 4;

	        var jRotationDivIn = $('<div/>', { // build the rotation dial div
	            'class': 'us_rotationDivInner' + ' ' + _defines2.default.clsOVERLAY,
	            css: {
	                'left': '8px', 'top': '8px', width: dialDiamPlus + 'px', height: dialDiamPlus + 'px'
	            }
	        });
	        jRotationDivIn.append(jRotationDial);
	        jRotationDiv.append(jRotationDivIn);
	        jVpDiv.append(jRotationDiv);
	        jRotationDiv = jVpDiv.find('.' + _defines2.default.clsROTATIONDIV); // save for quick access
	        jPresets = jVpDiv.find('.' + _defines2.default.clsROTATEPRESET); // save for quick access

	        var color = '#556571'; // unfortunately I cannot do this in css
	        jRotationDial = jVpDiv.find('.' + _defines2.default.clsROTATIONDIAL);
	        jRotationDial.knob({
	            'change': self.change, 'release': self.release, 'draw': self.draw,
	            'width': dialDiamPlus, 'height': dialDiamPlus, 'displayPrevious': true, 'fgColor': color,
	            'skin': 'aperio', 'cursor': true, 'value': '0', 'thickness': '.2', 'max': '360'
	        });
	        // override the hard coded font in the plug in
	        jRotationDial.css({ 'font-size': '9px', 'font-weight': 'bold', 'color': color });

	        viewport.overLayout.add(layout); // and call into layout with parms to place the div
	        isLoaded = true;
	        self.show(uScope.prefGet(_defines2.default.clsROTATIONDIV)); // show/hide according to user preferences
	        bindEvents_();
	        return;

	        //..................................................
	        // closure functions
	        //............................................ bindEvents_()
	        // bindEvents_ - This function adds the rotation dial event handlers.
	        //
	        //    Note that by using the same namespace as the viewport when the
	        //    viewport removes its events by namespace, these are also removed.

	        function bindEvents_() {
	            var namespace = viewport.eventNameSpaceGet();

	            // show/hide rotation dial on mode change
	            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
	                // show is true if this is the image selected and not in a mode that I'm supposed to hide during
	                var bshow = viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined ? true : false;
	                self.show(bshow);
	            });

	            // show/hide rotation dial if image is selected/not-selected
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
	                self.show(parms.uScopeIdx == viewport.getImageIdx());
	            });

	            // rotate image
	            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGEROTATE + namespace, function (e, parms) {
	                //? do this regardless of user pref?  what about vil settings?

	                // if this image is specified or ALL images are specified (parms.uScopeIdx == -1) then perform the rotation
	                if (parms.imageId == '@0' || parms.uScopeIdx == -1 || parms.imageId == imageId_ || parms.uScopeIdx == uScopeIdx_) viewport.viewRotate(parms.angleDeg);
	            });

	            // user preference update
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
	                //viewport.log("rotation dial us.evUSERPREFSREADY recvd");
	                self.show(uScope.prefGet(_defines2.default.clsROTATIONDIV));

	                reLayout(layout.precinct); // layout just this overlay's precinct
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
	                // parms: {className: STR, value: bool}
	                if (parms.className == _defines2.default.clsROTATIONDIV) {
	                    //viewport.log("rotation dial us.evUSERPREFSET recvd");
	                    self.show(parms.value);
	                }
	            });
	            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
	                //viewport.log("rotation dial us.evUSERPREFDEFAULTVISIBLE recvd");
	                uScope.prefSet(_defines2.default.clsROTATIONDIV, prefVisibleDef);
	            });

	            jPresets.on('click' + namespace, function (e) {
	                // preset click handler
	                var angleDeg = parseInt($(this).attr('angle'));
	                switch (angleDeg) {
	                    case 1:
	                        angleDeg = self.getValue() + 1;
	                        break;
	                    case -1:
	                        angleDeg = self.getValue() - 1;
	                        break;
	                    default:
	                }
	                //debug-only viewport.log("Rotate Preset Click:  angle: " + angleDeg);
	                self.setValue(angleDeg);
	                return false;
	            });

	            // commented out because this caused other problems... take another look sometime...
	            //    jRotationDiv.on("click"+namespace, function (e) {        // outer ring click handler
	            //        var pos = $(this).offset();
	            //        var dx = (e.pageX - pos.left + jRotationDiv.width() / 2);
	            //        var dy = (e.pageY - pos.top + jRotationDiv.height() / 2);
	            //        var mag = parseInt(Math.sqrt(dx * dx + dy * dy));
	            //        if (mag < dialDiamPx / 2 + 2)  // if click is not on outer ring return - handled by dial events
	            //            return;
	            //        var angleDeg = parseInt(90. + Math.atan2(dy,dx) * 180. / Math.PI);
	            //        //debug-only viewport.log("Rotate Ring Click: angle: " + angleDeg);
	            //        viewport.viewRotate(angleDeg);
	            //        xxxx use setrot.. viewport.angleDeg = angleDeg;//cp-this could move into viewRotate???
	            //        ///viewport.setDialRotationAngle(angleDeg); //cp-this could move also???
	            //        return false;
	            //    });
	        }
	        //..................................................
	    };

	    //............................................ construction
	    construct_();
	}
	module.exports = exports['default'];

/***/ }

});